export enum PointDetailTabOrder
{
    Activity, 
    Reservoir,
    Diagnostics,
    Metrics
}